import { render } from "./IndexComponent.vue?vue&type=template&id=09ab0736&scoped=true"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"

import "./IndexComponent.vue?vue&type=style&index=0&id=09ab0736&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ab0736"]])

export default __exports__